import type { WithOptional } from 'admin';
import { CURRENCY_OPTIONS } from 'api';

import { SelectField, type SelectFieldProps } from '../SelectField/SelectField';

type Props = Omit<WithOptional<SelectFieldProps, 'name' | 'required' | 'label'>, 'options'>;

export const CurrencySelectField = ({ name = 'currency', required = true, label = 'Currency', ...rest }: Props) => {
  return <SelectField label={label} name={name} required={required} options={CURRENCY_OPTIONS} {...rest} />;
};
